import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
/**
 * Hook providing navigation helpers for CRUD routes.
 * Derives the base list path from the current match.path
 * regardless of whether it's a list, detail, or form route.
 *
 * Every move keeps the current query string: it holds the list's filters, and a list that
 * is mounted again (after a form) or reloaded reads them from there (CZNA-1588).
 */
var useNavigation = function (matchPath) {
    var history = useHistory();
    var basePath = matchPath
        .replace('/create', '')
        .replace('/:id/edit', '')
        .replace('/:id', '');
    var push = useCallback(function (pathname) {
        history.push({ pathname: pathname, search: history.location.search });
    }, [history]);
    var goToList = useCallback(function () {
        push(basePath);
    }, [push, basePath]);
    var goToDetail = useCallback(function (id) {
        push("".concat(basePath, "/").concat(id));
    }, [push, basePath]);
    var goToCreate = useCallback(function () {
        push("".concat(basePath, "/create"));
    }, [push, basePath]);
    var goToEdit = useCallback(function (id) {
        push("".concat(basePath, "/").concat(id, "/edit"));
    }, [push, basePath]);
    return { goToList: goToList, goToDetail: goToDetail, goToCreate: goToCreate, goToEdit: goToEdit };
};
export default useNavigation;
